import { render } from "./List_Permissions.vue?vue&type=template&id=0136cc38&scoped=true"
import script from "./List_Permissions.vue?vue&type=script&lang=js"
export * from "./List_Permissions.vue?vue&type=script&lang=js"

import "./List_Permissions.vue?vue&type=style&index=0&id=0136cc38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0136cc38"]])

export default __exports__